import * as env from "util/env"

export const customFont = env.getMetaContentByName("calculators/font") || "cardinal-grotesque"

export const getFontClass = () => customFont

/* for inline styles (rechart graphs) and ignition button */
const fontFamilyIndex = () => ({
  "cardinal-grotesque": "Cardinal Grotesque",
  "frank-ruhl-libre": "'Frank Ruhl Libre', serif",
  "poppins": "'Poppins', sans-serif",
  "source-sans-pro": "'Source Sans Pro', sans-serif",
  "playfair-display": "'Playfair Display', serif",
  "ibm-plex-sans": "'IBM Plex Sans', sans-serif"
})

export const getFontFamily = () => fontFamilyIndex()[customFont]
